import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=ae9d7ade&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"
import style0 from "./Documents.vue?vue&type=style&index=0&id=ae9d7ade&prod&scoped=true&lang=css"
import style1 from "./Documents.vue?vue&type=style&index=1&id=ae9d7ade&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9d7ade",
  null
  
)

export default component.exports